import {DatePicker, LocalizationProvider, TimePicker} from "@mui/lab";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import enLocale from "date-fns/locale/en-GB";
import {Box, TextField} from "@mui/material";
import React from "react";

interface IDateTimePicker {
    date: number
    onValueChange: (value: any) => void
}
export function DateTimePicker({date, onValueChange}: IDateTimePicker) {
    const handleOnChange = (date: Date | null) => {
        if (date) {
            onValueChange(date.getTime());
        }
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={enLocale}>
            <Box display="flex">
                <DatePicker label="Date" value={date} onChange={handleOnChange} renderInput={(params) =>
                    <TextField size="small" sx={{margin: 1}} {...params}/>
                }/>
                <TimePicker onChange={handleOnChange} value={date} renderInput={(params) =>
                    <TextField size="small" sx={{margin: 1}} {...params}/>
                }/>
            </Box>
        </LocalizationProvider>
    );
}